import { api } from "./client";
import type {
  CaseSummary,
  CaseDetail,
  CaseStatus,
  CreateCaseRequest,
  UpdateCaseRequest,
  PagedResult,
} from "./types";

export async function listCases(params: {
  status?: CaseStatus;
  q?: string;
  page?: number;
  pageSize?: number;
}) {
  const { data } = await api.get<PagedResult<CaseSummary>>("/cases", {
    params,
  });
  return data;
}

export async function getCase(id: string) {
  const { data } = await api.get<CaseDetail>(`/cases/${id}`);
  return data;
}

export async function createCase(body: CreateCaseRequest) {
  const { data } = await api.post<CaseDetail>("/cases", body);
  return data;
}

export async function updateCase(id: string, body: UpdateCaseRequest) {
  const { data } = await api.patch<CaseDetail>(`/cases/${id}`, body);
  return data;
}

export async function deleteCase(id: string, hard = false) {
  await api.delete(`/cases/${id}`, {
    params: hard ? { hard: true } : undefined,
  });
}

export async function addInstanceToCase(caseId: string, instanceId: string) {
  await api.post(`/cases/${caseId}/instances/${instanceId}`);
}

export async function removeInstanceFromCase(
  caseId: string,
  instanceId: string,
) {
  await api.delete(`/cases/${caseId}/instances/${instanceId}`);
}
